// src/components/auth/ProtectedRoute.js
// 20.02.26 - Added suspension check to block suspended users
import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getFirestore, doc, getDoc } from 'firebase/firestore';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { currentUser, loading, userRole } = useAuth();
  
  if (loading) {
    return (
      <div className="loading-container" style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        height: '100vh'
      }}>
        <div className="loading-spinner"></div>
      </div>
    );
  }
  
  if (!currentUser) {
    return <Navigate to="/login" />;
  }
  
  if (requireAdmin && userRole !== 'admin') {
    return <Navigate to="/" />;
  }

  return <SuspensionCheck>{children}</SuspensionCheck>;
};

const SuspensionCheck = ({ children }) => {
  const { currentUser } = useAuth();
  const [suspended, setSuspended] = useState(null);

  useEffect(() => {
    const checkStatus = async () => {
      try {
        const db = getFirestore();
        const userDoc = await getDoc(doc(db, 'Users', currentUser.email));
        if (userDoc.exists() && userDoc.data().accountStatus === 'suspended') {
          setSuspended(true);
        } else {
          setSuspended(false);
        }
      } catch (err) {
        console.warn('20.02.26 - Suspension check failed:', err.message);
        setSuspended(false);
      }
    };
    checkStatus();
  }, [currentUser]);

  if (suspended === null) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', 
        alignItems: 'center', height: '100vh' }}>
        <div className="loading-spinner"></div>
      </div>
    );
  }

  if (suspended) {
    return <Navigate to="/account-suspended" />;
  }

  return children;
};

export default ProtectedRoute;